import NestedMenuItem, { NestedMenuItemProps } from './NestedMenuItem';

export type { NestedMenuItemProps };
export default NestedMenuItem;
